import { ActorLayoutVariant } from "features/new-actor/enums/actorLayoutVariant";
import { BaseLegalEntityFormFieldNames } from "shared/enums/baseLegalEntityFormFieldNames";
import { LegalEntityFormFieldNames } from "features/new-actor/enums/legalEntityFormFieldNames";
import { PersonalInformationFieldNames } from "features/new-actor/enums/personalInformationFieldNames";
import { LegalEntityFormValues } from "features/new-actor/types/legalEntityFormValues";
import { LayoutFieldsDisabledRulesType, LayoutFieldsDisplayRulesType } from "types/form/layoutFieldRules";
import { LayoutFieldRulesNames } from "./layoutConfig";

export type LegalEntityDisplayRules = LayoutFieldsDisplayRulesType<ActorLayoutVariant, LayoutFieldRulesNames>

export const legalEntityLayoutFieldsDisplayRules: LegalEntityDisplayRules = {
  [ActorLayoutVariant.BorrowerActors]: {
    [LegalEntityFormFieldNames.CompanyName]: {
      add: true,
      edit: true,
    },
    [LegalEntityFormFieldNames.CompanyRole]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.DefaultActor]: {
    [LegalEntityFormFieldNames.CompanyName]: {
      add: true,
      edit: true,
    },
    [LegalEntityFormFieldNames.CompanyRole]: {
      add: true,
      edit: true,
    },
  },
  [ActorLayoutVariant.InsuredActor]: {
    [LegalEntityFormFieldNames.CompanyName]: {
      add: true,
      edit: true,
    },
    [LegalEntityFormFieldNames.CompanyRole]: {
      add: true,
      edit: true,
    },
  },
}

export const legalEntityDisabledFields: Array<keyof LegalEntityFormValues> = [
  BaseLegalEntityFormFieldNames.RegistrationNumber,
  BaseLegalEntityFormFieldNames.RcsCity,
  BaseLegalEntityFormFieldNames.RcsNumber,
  PersonalInformationFieldNames.LastName,
  PersonalInformationFieldNames.FirstName,
  PersonalInformationFieldNames.Civility,
];

export type LegalEntityDisabledRules = LayoutFieldsDisabledRulesType<ActorLayoutVariant, keyof LegalEntityFormValues>

export const legalEntityLayoutFieldsDisabledRules: LegalEntityDisabledRules = {
  [ActorLayoutVariant.DefaultActor]: legalEntityDisabledFields,
  [ActorLayoutVariant.InsuredActor]: legalEntityDisabledFields,
}
